module.exports = __webpack_public_path__ + "static/media/music.19fa1482.png";